import api from './api';

const produccionLineaService = {
  async list(params = {}) {
    const response = await api.get('/produccion/lineas', { params });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/produccion/lineas', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/produccion/lineas/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/produccion/lineas/${id}`);
    return response.data;
  },
};

export default produccionLineaService;
